import { Box, Divider, Modal, Container, Fade, Skeleton } from '@mui/material';

export const List = ({open, setOpen, loader, tools, HandleClickTools }) => {
    return (
        <Modal open={open}  
            onClose={()=>setOpen(false)}
            sx={{borderColor:'none !important'}}
            BackdropProps={{style: { backgroundColor: 'transparent', borderColor:'none !important' } }}
            className="noutlined"
        >
            <Fade in={open} direction="down" className="noutlined">
                <Box position="absolute" top={150} minHeight="309px" width="100%" bgcolor="#FFFFFF">
                    <Container maxWidth="xl">
                        <Box height="100%" width="100%" py="56px" display="flex" flexDirection="column" gap="20px">
                            <Box fontWeight={600} fontSize={16} lineHeight="23px" color="#333333">Tool Categories</Box>
                            <Divider sx={{bgcolor:'#C9D6DF'}}/>
                            <Box display="flex" gap="32px" flexWrap="wrap">
                                {loader ?
                                    (['', '', '', ''].map((v,k) => (
                                        <Box key={k} display="flex" flexDirection="column" gap="16px" py="6px">
                                            <Box fontWeight={400} fontSize={14} lineHeight="23px" color="#333333">
                                                <Skeleton variant="text" width="120px" height="30px" />
                                            </Box>
                                            <Box display="flex" flexDirection="column" gap="16px">
                                                {['','',''].map((d,k) => (
                                                    <Box key={k} display="flex" alignItems="center" gap="12px" className="c-pointer" minHeight="48px" p="12px">
                                                        <Skeleton variant="rectangular" width="24px" height="24px" sx={{borderRadius:'6px'}}/>
                                                        <Skeleton variant="text" width="120px" height="24px" />
                                                    </Box>
                                                ))}
                                            </Box>
                                        </Box>

                                    )))
                                :
                                    (tools.map((v,k) => (
                                        <Box key={k} display="flex" flexDirection="column" gap="16px" className="c-pointer" py="6px">
                                            <Box fontWeight={400} fontSize={14} lineHeight="23px" color="#333333">{v.name}</Box>
                                            <Box display="flex" flexDirection="column" gap="16px">
                                                {v.tools.map((d,k) => (
                                                    <Box key={k} onClick={() => HandleClickTools(d)} display="flex" alignItems="center" gap="12px" sx={{':hover':{bgcolor:'#F0F5F9', borderRadius:'6px', width:'auto'} }} minHeight="48px" p="12px">
                                                        <img src={JSON.parse(d.logo)} alt="Pofsis-Business"  height={24} width={24} />
                                                        <Box fontWeight={600} lineHeight="23px" textAlign="center" fontSize="14px">{d.name}</Box>
                                                    </Box>
                                                ))}
                                            </Box>
                                        </Box>

                                    )))
                                }
                            </Box>
                        </Box>
                    </Container>
                </Box>
            </Fade>
        </Modal>
    )
}